import React from 'react';

import cs from 'classnames';
import produce from 'immer';

import {FormControlGroup} from 'app/general/forms';
import {gt} from 'app/utils/i18n';

import {AssignUsersField, BaseProps} from './AssignUsersField';

import type {AllAssignmentsType} from './types';

interface Props extends BaseProps {
  assignments: AllAssignmentsType;
  onChange: (assignments: AllAssignmentsType) => unknown;
}

export function GlobalAssignUsersField({
  assignments,
  onChange,
  locked,
  field = '',
  noMargin = false,
}: Props): JSX.Element {
  return (
    <div className="form-row">
      <FormControlGroup
        field={field}
        className={cs('col-12', {'mb-0': noMargin})}
      >
        <label>{gt('Assign to teammates')}</label>
        <AssignUsersField
          assignments={assignments.global}
          onChange={(meta, ctname) =>
            onChange(
              produce(assignments, (draft) => {
                const ctnamePlural = `${ctname}s`;

                if (meta.action === 'select-option') {
                  draft.global[ctnamePlural].push(meta.option);
                } else if (meta.action == 'remove-value') {
                  draft.global[ctnamePlural] = draft.global[
                    ctnamePlural
                  ].filter((a) => a.url !== meta.removedValue.url);
                  // global assignee removed. keep granular up to date.
                  draft.granular = draft.granular.filter(
                    (a) => a[ctname]?.url !== meta.removedValue.url
                  );
                } else if (meta.action == 'clear') {
                  draft.global[ctnamePlural] = [];
                  draft.granular = draft.granular.filter(
                    (a) => a[ctname] == null
                  );
                }
              })
            )
          }
          locked={locked}
        />
      </FormControlGroup>
    </div>
  );
}
